"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var subscription_1 = require("../../../api/subscription");
var LicenseDeleteButton = function (props) {
    var buttonLabel = props.buttonLabel, className = props.className;
    var _a = react_1.useState({ id: "" }), graphData = _a[0], setGraphData = _a[1];
    var _b = react_1.useState(0), companyId = _b[0], setCompanyId = _b[1];
    var _c = react_1.useState({ id: 0, name: "", unit: "", companyId: "", licenseId: "" }), licenseData = _c[0], setLicenseData = _c[1];
    var _d = react_1.useState(false), modal = _d[0], setModal = _d[1];
    var toggle = function () { return setModal(!modal); };
    var submitDeleteLicense = function () {
        subscription_1.deletePurchasedLicense(graphData, licenseData.companyId, licenseData.id).then(function (response) {
            props.modalCallback();
        });
        toggle();
    };
    var onLoad = function () {
        var id = 1;
        if (props.id) {
            setCompanyId(props.id);
        }
        if (licenseData.id == 0 && props.list != null && props.list.length > 0)
            setLicenseData(props.list.reduce(function (acc, item) { if (props.id == item.id)
                acc = item; return acc; }, { id: 0 }));
        setGraphData(props.userId);
    };
    react_1.useEffect(function () {
        onLoad();
        console.log(licenseData);
    }, [licenseData, setLicenseData]);
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { style: { padding: 0 }, color: "link", onClick: toggle },
            React.createElement("a", { className: "padding-default" },
                React.createElement("img", { src: "./delete.svg", className: "font-icon" }))),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }),
            React.createElement(reactstrap_1.ModalBody, { id: "delete-body" }, "Are you sure want to delete this?"),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return submitDeleteLicense(); } }, "Yes, Delete")))));
};
exports.default = LicenseDeleteButton;
//# sourceMappingURL=LicenseDeleteButton.js.map